import { FollowListFrom } from './hook';

export const getDefaultOrder = (from: FollowListFrom, isFollowing?: boolean) => {
  if (['collection', 'user', 'token'].includes(from)) {
    if (isFollowing) {
      return '-to_usd_value';
    } else {
      return '-create_at';
    }
  }
  if (from === 'official') {
    return '-user_usd_value';
  }
};

export const getNetWorthOrderKey = (from: FollowListFrom, isFollowing?: boolean) => {
  if (from === 'user') {
    if (isFollowing) {
      return 'to_usd_value';
    } else {
      return 'from_usd_value';
    }
  }
  if (from === 'official') {
    return 'user_usd_value';
  }
};
